import React, { useContext, useState, useEffect } from "react";
import SingleBar from "charts/SingleBar";
import { DataContext } from "App";
import { getHourNum } from "utils/index";

const data = [
  { name: "一线", value: 0.10737418985 },
  { name: "新一线", value: 0.1907423311 },
  { name: "二线", value: 0.1847650033 },
  { name: "三线", value: 0.22631407735 },
  { name: "四线", value: 0.1797097059 },
  { name: "五线", value: 0.1026040954 },
];

const City: React.FC = () => {
  const appData = useContext(DataContext);
  const [hourData, setHourData] = useState<{ name: string; value: number }[]>(
    []
  );

  useEffect(() => {
    let Timer: NodeJS.Timeout;

    function setData() {
      setHourData(
        data.map(({ name, value }) => ({
          name,
          value: Math.round(
            value * getHourNum(appData?.total?.today?.imp, appData?.percent)
          ),
        }))
      );
      Timer = setTimeout(() => setData(), 30000);
    }

    setData();

    return () => {
      clearTimeout(Timer);
    };
  }, [appData]);

  return <SingleBar data={hourData} border />;
};

export default City;
